import Vue from "vue";
import Storage from "vue-ls";
import {
  XInput,
  XButton,
  Group,
  ToastPlugin,
  Popup,
  XTextarea,
  PopupHeader,
  Confirm,
  LoadingPlugin,
  LoadMore,
  TransferDom,
  Cell,
  CellBox,
  Actionsheet,
  XDialog,
  Datetime,
  DatetimeRange,
  XNumber,
  Selector,
  dateFormat,
  PopupRadio,
  Tab,
  TabItem,
  Previewer,
  CheckIcon,
  Spinner,
  Flexbox,
  FlexboxItem
} from "vux";
import { Card, CardItem } from "@/components/Card";
// import XInput from "@/components/FormItem/XInput";

/* eslint-enable */

const options = {
  namespace: "vuejs__", // key prefix
  name: "ls", // name variable Vue.[ls] or this.[$ls],
  storage: "local" // storage name session, local, memory
};

Vue.use(Storage, options);

Vue.use(LoadingPlugin);
Vue.use(ToastPlugin);
Vue.component(XButton.name, XButton);
Vue.component(XInput.name, XInput);
// Vue.component("XInput", XInput);
Vue.component(Group.name, Group);
Vue.component(Popup.name, Popup);
Vue.component(XTextarea.name, XTextarea);
Vue.component(PopupHeader.name, PopupHeader);
Vue.component(Confirm.name, Confirm);
Vue.component(LoadMore.name, LoadMore);
Vue.component(Cell.name, Cell);
Vue.component(CellBox.name, CellBox);
Vue.component(Actionsheet.name, Actionsheet);
Vue.component(XDialog.name, XDialog);
Vue.component(Datetime.name, Datetime);
Vue.component(DatetimeRange.name, DatetimeRange);
Vue.component(Selector.name, Selector);
Vue.component(XNumber.name, XNumber);
Vue.component(PopupRadio.name, PopupRadio);
Vue.component(TabItem.name, TabItem);
Vue.component(Tab.name, Tab);
Vue.component(Previewer.name, Previewer);
Vue.component(CheckIcon.name, CheckIcon);
Vue.component(Spinner.name, Spinner);
Vue.component(FlexboxItem.name, FlexboxItem);
Vue.component(Flexbox.name, Flexbox);
Vue.component("card", Card);
Vue.component("card-item", CardItem);
Vue.directive("TransferDom", TransferDom);
Vue.filter("datetime", dateFormat);

/* eslint-disable */

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (search, this_len) {
    if (this_len === undefined || this_len > this.length) {
      this_len = this.length
    }
    return this.substring(this_len - search.length, this_len) === search
  }
}


